// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoCircleFilledSvg from "@ant-design/icons-svg/es/asn/InfoCircleFilled";
import AntdIcon from '../components/AntdIcon';

var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleFilledSvg
  }));
};

InfoCircleFilled.displayName = 'InfoCircleFilled';
export default React.forwardRef(InfoCircleFilled);